import { useLang } from '../LangContext';

const reviews = [
  { name: 'Khushi Shukla', meta: '1 review · a year ago', avatar: '👩', stars: 5, text: 'This "Kids play hall" is the perfect spot for kids to burn off energy! With a variety of activities like soft play areas, obstacle courses, and ball pits, this space is clean, safe, reasonable and the staff is friendly. Highly recommend!!!' },
  { name: 'Abhishek Pandey', meta: '2 reviews · a year ago', avatar: '👨', stars: 5, text: 'The school focuses on holistic development of children providing practical knowledge with learning skills. Both the teachers were good and experienced and provide a safe environment. Highly recommended!' },
  { name: 'Yuvraj', meta: '1 review · a year ago', avatar: '👦', stars: 5, text: 'Nice pre school, very safe and exciting place for kids, highly recommended!' },
  { name: 'Rashmi Shukla', meta: '4 reviews · a year ago', avatar: '👩', stars: 5, text: 'Great experience at Kids Play Hall! Clean, safe, and fun for kids. Friendly staff and reasonable prices. Highly recommend!!! 🤩💗' },
  { name: 'Nishi Abhi Shukla', meta: '1 review · a year ago', avatar: '👩', stars: 5, text: 'Very good for lil kids.' },
  { name: 'Supri', meta: '1 review · a year ago', avatar: '🧑', stars: 5, text: 'Very nice environment for kids to learn and play with nice staff 📚🖊️👍' },
];

function StarRating({ count }) {
  return (
    <div className="star-rating">
      {Array.from({ length: 5 }, (_, i) => (
        <span key={i} style={{ color: i < count ? '#f9a825' : '#ddd' }}>★</span>
      ))}
    </div>
  );
}

export default function Reviews() {
  const { t } = useLang();

  return (
    <section id="reviews" className="reviews">
      <span className="section-tag center">{t.reviewsTag}</span>
      <h2 className="section-title">{t.reviewsTitle}</h2>
      <div className="rating-summary">
        <span className="rating-score">4.7</span>
        <div>
          <div className="rating-stars">⭐⭐⭐⭐⭐</div>
          <div className="rating-label">{t.reviewsOf} 5 · {reviews.length} {t.reviewsCount}</div>
        </div>
      </div>
      <div className="reviews-grid">
        {reviews.map((r) => (
          <div className="review-card" key={r.name}>
            <div className="review-header">
              <span className="review-avatar">{r.avatar}</span>
              <div className="review-info">
                <div className="review-name">{r.name}</div>
                <div className="review-meta">{r.meta}</div>
              </div>
            </div>
            <StarRating count={r.stars} />
            <p className="review-text">"{r.text}"</p>
          </div>
        ))}
      </div>
    </section>
  );
}
